var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table"},[_c('div',{staticClass:"cell"},[_c('div',{staticClass:"gmb-loader"},[_c('div'),_c('div'),_c('div')])])])
}]

export { render, staticRenderFns }